import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import _ from 'lodash'
import get from 'lodash/get'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  authAction,
  departmentAction,
  divisionAction,
  modalAction,
} from './../../actions/'
import {
  authSelector,
  divisionSelector,
  departmentSelector,
  modalSelector,
} from './../../selectors'
import { searchDivisions } from '../../function'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import EditDivision from './edit'
import ListDivision from './list'
import DivisionForm from '../../components/division'
import CustomModal from '../../components/modal'
import CustomModalMessage from '../../components/modal-message'

class DivisionPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      id: '',
      span: false,
      division_code: '',
      division: '',
      department_id: '',
      start_date: '',
      search: '',
      defaultDivisions: [],
      divisions: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSpan = this.handleSpan.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.cancelAlert = this.cancelAlert.bind(this)
    this.showSave = this.showSave.bind(this)
    this.cancelSave = this.cancelSave.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.listDepartment(access_token)
  }
  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'listDivisionData') && this.state.search === '') {
      this.setState({
        divisions: _.get(nextProps, 'listDivisionData'),
        defaultDivisions: _.get(nextProps, 'listDivisionData'),
      })
    }
    if (_.get(nextProps, 'divisionCreate.divisionCreate')) {
      this.props.showModal(
        'division',
        _.get(nextProps, 'divisionCreate.status'),
        _.get(nextProps, 'divisionCreate.message')
      )
      this.props.listDivision(localStorage.getItem('access_token'))
      this.props.resetCreateDivision()
    }
    if (_.get(nextProps, 'divisionEdit.divisionEdit')) {
      this.setState({
        edit: false,
      })
      this.props.showModal(
        'division',
        _.get(nextProps, 'divisionEdit.status'),
        _.get(nextProps, 'divisionEdit.message')
      )
      if (_.get(nextProps, 'divisionEdit.status') === 200) this.showSave()
      this.props.listDivision(localStorage.getItem('access_token'))
      this.props.resetEditDivision()
      this.handleClickEdit(false, '')
    }
    if (_.get(nextProps, 'divisionDeactivate.divisionDeactivate')) {
      this.props.showConfirm(
        'deleteDivision',
        _.get(nextProps, 'divisionDeactivate.status'),
        _.get(nextProps, 'divisionDeactivate.message')
      )
      this.props.listDivision(localStorage.getItem('access_token'))
      this.props.resetDeactivateDivision()
    }
    if (_.get(nextProps, 'exportURL')) {
      window.open(_.get(nextProps, 'exportURL'), 'blank')
      this.props.resetExportDivision()
    }
  }
  handleClickSearch() {
    this.setState({ divisions: _.get(this.state, 'defaultDivisions').filter(searchDivisions, this.state.search) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ divisions: _.get(this.state, 'defaultDivisions'), search: '' })
    else this.setState({ search: e.target.value })
  }
  handleClickEdit(editDivision, division_id) {
    this.setState({
      edit: editDivision,
      id: division_id,
    })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleSpan(spanList) {
    this.setState({ span: spanList })
  }
  showSave() {
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your division information had been saved.')
  }
  cancelSave() {
    this.props.hideConfirm('confirmSave')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  showDiscard() {
    this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  showForm() {
    this.handleClickEdit(false, '')
    this.handleSpan(false)
    this.props.showModal('divisionForm')
  }
  cancelForm() {
    this.props.hideModal('divisionForm')
  }
  cancelAlert() {
    this.props.hideModal('division')
  }
  submitForm() {
    this.props.createDivision(
      {
        division_code: this.state.division_code,
        name: this.state.division,
        department_id: _.get(this.state, 'department_id') === '' ? _.get(this.props, 'listDepartmentData')[0]._id : _.get(this.state, 'department_id'),
        start_date: new moment(this.state.start_date),
        is_active: this.state.is_active,
      },
      localStorage.getItem('access_token'))
  }

  render() {
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectDivision.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectDivision.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    const button = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
      </div>
    )
    const buttonOK = (
      <div>
        <NewButton color="info" onClick={ this.cancelSave }>OK</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetchingDepartment')
    || get(this.props, 'getIsFetchingDivision')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          export={ () => this.props.exportDivision(localStorage.getItem('access_token')) }
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        {
          _.get(this.props, 'modalType') === 'division' &&
            <CustomModal
              hide={ this.cancelAlert }
              show={ _.get(this.props, 'modalType') === 'division' }
              type={ _.get(this.props, 'modalStatus') }
              message={ _.get(this.props, 'modalMessage') }
            />
        }
        {
          _.get(this.props, 'confirmType') === 'confirmSave' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ _.get(this.props, 'confirmType') === 'confirmSave' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        {
          _.get(this.props, 'confirmType') === 'deleteDivision' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ _.get(this.props, 'confirmType') === 'deleteDivision' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        <Row noGutters>
          <Col>
            <ListDivision
              handleClickEdit={ this.handleClickEdit }
              handleSpan={ this.handleSpan }
              span={ this.state.span }
              divisions={ this.state.divisions }
              table={ 3 }
            />
          </Col>
          {
            this.state.span && <Col>
              <EditDivision
                edit={ this.state }
                handleClickEdit={ this.handleClickEdit }
                handleSpan={ this.handleSpan }
                cancelForm={ this.cancelForm }
                showDelete={ this.showDelete }
                cancelDelete={ this.cancelDelete }
                showDiscard={ this.showDiscard }
                cancelDiscard={ this.cancelDiscard }
                confirm={ _.get(this.props, 'confrimType') }
                confirmStatus={ _.get(this.props, 'confirmStatus') }
                confirmType={ _.get(this.props, 'confirmType') }
                confirmMessage={ _.get(this.props, 'confirmMessage') }
              />
            </Col>
          }
        </Row>
        <Modal isOpen={ _.get(this.props, 'modalType') === 'divisionForm' } toggle={ this.cancelForm }>
          <DivisionForm
            create={ true }
            list={ _.get(this.props, 'listDepartmentData') }
            division_code={ this.state.division_code }
            division={ this.state.division }
            department_id={ this.state.department_id }
            start_date={ this.state.start_date }
            button={ button }
            confirm={ _.get(this.props, 'modalType') }
            submitForm={ this.submitForm }
            handleClickEdit={ this.handleClickEdit }
            handleInput={ this.handleInput }
            cancelForm={ this.cancelForm }
            modalStatus={ _.get(this.props, 'modalStatus') }
            modalType={ _.get(this.props, 'modalType') }
          />
        </Modal>
      </Wrapper>
    )
  }
}

DivisionPage.propTypes = {
  createDivision: PropTypes.func.isRequired,
  resetCreateDivision: PropTypes.func.isRequired,
  listDivision: PropTypes.func.isRequired,
  listDepartment: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  resetEditDivision: PropTypes.func.isRequired,
  resetDeactivateDivision: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  redirectAuth: authSelector.redirectAuth,
  redirectDivision: divisionSelector.redirectDivision,
  getIsFetchingDepartment: departmentSelector.getIsFetching,
  getIsFetchingDivision: divisionSelector.getIsFetching,
  listDepartmentData: departmentSelector.getListDepartment,
  listDivisionData: divisionSelector.getListDivision,
  divisionCreate: divisionSelector.getCreateDivisionData,
  divisionEdit: divisionSelector.getEditDivisionData,
  divisionGet: divisionSelector.getGetDivisionData,
  divisionDeactivate: divisionSelector.getDeactivateDivisionData,
  exportURL: divisionSelector.getExportURL,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  createDivision: divisionAction.createDivision,
  resetCreateDivision: divisionAction.resetCreateDivision,
  resetEditDivision: divisionAction.resetEditDivision,
  resetDeactivateDivision: divisionAction.resetDeactivateDivision,
  listDivision: divisionAction.getDivision,
  listDepartment: departmentAction.getDepartment,
  exportDivision: divisionAction.exportDivision,
  resetExportDivision: divisionAction.resetExportDivision,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(DivisionPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/division/index.js